import { useState, useEffect, useRef } from "react";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import { InterUserMangementServices } from "../services/InternalUserMangementServices";
import { CircularProgress } from "@mui/material";
import EditIcon from "../assets/editIcon.svg";
import { Switch } from "@mui/material";
import SearchIcon from "../assets/searchIcon.svg";

import AddMore from "../assets/addMoreIcon.svg";
import { useNavigate } from "react-router-dom";
import { updateUser } from "../services/AdminServices";
import UpdateUserDetails from "./UpdateUserDetails";
import CustomPagination from "../utils/paginationUtils";
import "./InternalUsers.scss";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
const InternalUsers = () => {
  const [users, setUsers] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [selectedUser, setSelectedUser] = useState(-1);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [count, setCount] = useState(0);
  const navigate = useNavigate();
  let searchTimeRef = useRef();
  const limit = 10;
  const handleSearch = (e) => {
    //debouncing structure
    if (searchTimeRef.current) {
      clearInterval(searchTimeRef.current);
    }
    searchTimeRef.current = setTimeout(() => {
      setSearchKey(e.target.value);
    }, 500);
  };

  const getUserData = async () => {
    setLoading(true);
    try {
      const response = await InterUserMangementServices.getTeamUser(
        limit,
        page,
        searchKey
      );
      setUsers(response?.data?.teamUsers);
      setTotalPages(response?.data?.totalPages);
      setCount(response?.data?.total);
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setLoading(false);
  };
  const handleStatusChange = async (userStatus, userId) => {
    const data = {
      userid: userId,
      status: userStatus === "ACTIVE" ? "DISABLE" : "ACTIVE",
    };
    try {
      const response = await updateUser(data);
      getUserData();
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  useEffect(() => {
    getUserData();
  }, [page, searchKey, count]);
  return (
    <div className="manage-box">
      <span className="path_line">
        <WidgetsOutlinedIcon style={{ height: "24px" }} /> &nbsp; &nbsp;/ &nbsp;
        &nbsp; Dashboard &nbsp; &nbsp;/ &nbsp; &nbsp; Internal Uses
      </span>
      <div className="flex justify-between items-center">
        <div className="heading">Internal Users ({count})</div>
        <div className="flex gap-4 items-center">
          <div
            style={{ border: "1px solid #E4E4E4" }}
            className="flex items-center gap-2 rounded-[8px] px-4 py-[6px]"
          >
            <img src={SearchIcon} alt="search-icon" />
            <input
              type="text"
              placeholder="Search User"
              style={{ border: "0" }}
              className="outline-none"
              onChange={handleSearch}
            />
          </div>
          <div
            className="flex items-center gap-2 text-sm text-white bg-[#017C57] font-semibold uppercase px-5 py-2 rounded-full cursor-pointer"
            onClick={() => navigate("/dashboard/internal-user-management")}
          >
            <img src={AddMore} alt="add-more-icon" />
            Add User
          </div>
        </div>
      </div>
      <hr
        style={{ width: "100%", border: "1px solid rgba(228, 228, 228, 1)" }}
      />
      <div
        style={{ border: "1px solid #DEDEDE" }}
        className="mt-4 p-4 rounded-[16px]"
      >
        <div className="grid grid-cols-9 items-center p-4">
          <div className="font-medium text-[#191919]">Name</div>
          <div className="font-medium text-[#191919]">Alias Name</div>
          <div className="font-medium text-[#191919] col-span-2">Email</div>
          <div className="font-medium text-[#191919]">Phone Number</div>
          <div className="font-medium text-[#191919]">Role</div>
          {/* <div className="font-medium text-[#191919]">
            Status Responsibility
          </div> */}
          <div className="font-medium text-[#191919]">Status</div>
          <div className="font-medium text-[#191919] text-center">Action</div>
        </div>
        {loading ? (
          <div className="flex justify-center mt-4">
            <CircularProgress />
          </div>
        ) : (
          <div>
            {users?.map((user, idx) => {
              return (
                <div
                  key={idx}
                  className={`grid grid-cols-9  gap-1 justify-around ${
                    idx % 2 === 0 ? "bg-white" : "bg-[#F7F7F7]"
                  } p-4 rounded-[8px]`}
                >
                  <div>{user.fullName}</div>
                  <div>{user.userName}</div>
                  <div className="col-span-2">{user.email}</div>
                  <div>{user.phone}</div>
                  <div>{user?.userrolemappings[0]?.role?.roleName} </div>
                  {/* <div>--- </div> */}
                  <div>
                    {user.status === "ACTIVE" ? "Active" : "Inactive"}{" "}
                    <Switch
                      checked={user.status === "ACTIVE"}
                      onChange={() => {
                        if (
                          window.confirm(
                            "Are you sure you want to change user status."
                          )
                        ) {
                          handleStatusChange(user.status, user.id);
                        }
                        // setSelectedUser(user);
                      }}
                      inputProps={{ "aria-label": "toggle status" }}
                      style={{ color: "#017C57" }}
                    />
                  </div>
                  <div className="flex justify-center items-center ">
                    <img
                      src={EditIcon}
                      alt="edit-icon"
                      className="cursor-pointer"
                      onClick={() => setSelectedUser(idx)}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
      <div className="flex justify-center mt-5">
        <CustomPagination
          page={page}
          setPage={setPage}
          totalPages={totalPages}
        />
      </div>
      {users && users.length > 0 && selectedUser !== -1 && (
        <UpdateUserDetails
          userDetails={users[selectedUser]}
          getUserData={getUserData}
          isOpen={setSelectedUser}
        />
      )}
    </div>
  );
};

export default InternalUsers;
